import React from "react";
import "../styles/Hero.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  HERO_SUBTITLE,
  HERO_TITLE,
  HERO_TITLE_EMPHASIS,
  HERO_EYEBROW,
  INPUT,
  OUTPUT,
  CROP_ADVISORY,
  FINANCIAL,
} from "../data/navbar/menu";
import { statsDetails } from "../data/stats";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section className="hero" id="home">
      <div className="hero-illustration" aria-hidden="true">
        <svg viewBox="0 0 620 640" preserveAspectRatio="xMidYMid slice">
          <g stroke="rgba(15, 120, 100, 0.16)" strokeWidth="1" fill="none">
            <path d="M60,420 L260,360 L520,430 L480,560 L180,600 L40,540 Z" />
            <path d="M260,360 L340,240 L560,300 L520,430 Z" />
            <path d="M60,420 L120,300 L260,360 Z" />
            <path d="M340,240 L400,140 L560,180 L560,300 Z" />
          </g>
          <g stroke="rgba(15, 120, 100, 0.13)" strokeDasharray="3,4">
            <line x1="180" y1="80" x2="300" y2="330" />
            <line x1="180" y1="80" x2="470" y2="240" />
            <line x1="180" y1="80" x2="500" y2="470" />
          </g>
          <circle cx="180" cy="80" r="4" fill="#0f9045" />
          <circle cx="180" cy="80" r="9" fill="#0f9045" opacity="0.2" />
        </svg>
      </div>

      <div className="hero-inner">
        <span className="eyebrow">
          <span className="eyebrow-dot" />
          {t(HERO_EYEBROW)}
        </span>
        <h1 className="hero-title">
          {t(HERO_TITLE)} <em>{t(HERO_TITLE_EMPHASIS)}</em>
        </h1>
        <p className="hero-subtitle">{t(HERO_SUBTITLE)}</p>
        <div className="hero-pills">
          <a href="/#services" className="pill">
            {t(INPUT)}
          </a>
          <a href="/#services" className="pill">
            {t(OUTPUT)}
          </a>
          <a href="/#services" className="pill">
            {t(CROP_ADVISORY)}
          </a>
          <a href="/#services" className="pill">
            {t(FINANCIAL)}
          </a>
        </div>
      </div>

      <div className="hero-stats">
        {statsDetails.map((stat, index) => (
          <div className={`data-card data-card-${index + 1}`} key={stat.detail}>
            <FontAwesomeIcon icon={stat.icon} className="stat-icon" />
            <span className="stat-number">{stat.number}</span>
            <span className="stat-label">{t(stat.detail)}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
